import { AlarmCategory } from '@core/referential/alarm-category.enum'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'

// `category` lève l'ambiguïté quand un parent apparaît dans deux catégories
// (ses points de défaut + son bucket Batterie partagent le même equipmentId).
export const SearchSchema = z.object({
  category: z.nativeEnum(AlarmCategory).optional(),
})

export const Route = createFileRoute('/_dashboard/site/$id/defaults/$equipmentId/')({
  validateSearch: SearchSchema,
  pendingComponent: PendingComponent,
})
